import type {Day} from '../Time';

export type RootStackParamList = {
  PromptSetup: undefined;
  ShowProgress: {tab?: ProgressTab} | undefined;
  PromptSettings: undefined;
  ShowDaily: {shift?: `${Day}`} | undefined;
  ShowInsight: {quoteId?: `${number}`; topicId?: `${number}`} | undefined;
  ShowMeetingCard: {id?: `${number}`} | undefined;
  ListCities: {name?: string} | undefined;
  ListGroups: {cityId?: `${number}`} | undefined;
  ShowGroup: {id?: `${number}`} | undefined;
};

export enum ProgressTab {
  Accumulative = 'yMd',
  Months = 'M',
  Days = 'd',
}
